import {createSelector} from 'reselect';
import {getContactNumberRules, getSettings} from '../selectors';

export default createSelector(
  [getSettings, getContactNumberRules],
  (settings, fieldRules) => settings?.contact_number_max_length || fieldRules?.maxLength,
);
